import { Alert, Link } from "@mui/material"
import { If } from "lib/@components/switch"
import { InfoButton } from "lib/@components/colored-buttons/info-button"

export function RateCardEditorAlerts({ card, reviewDismissed, onRestoreSkillMap, onDismissReview }) {
    return (
        <>
            <If value={card.skillMapIsArchived}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    The linked skill map "{card.skillMapName}" has been archived. Trade names may be stale.{" "}
                    <Link
                        component="button"
                        variant="body2"
                        onClick={onRestoreSkillMap}
                        sx={{ verticalAlign: "baseline" }}
                    >
                        View skill map
                    </Link>
                </Alert>
            </If>

            <If value={card.needsReview && !reviewDismissed}>
                <Alert severity="info" data-cy="rate-card-needs-review" action={renderDismissAction()} sx={{ mb: 2 }}>
                    The linked skill map has been updated. Please review trade rates and update as needed.
                </Alert>
            </If>
        </>
    )

    function renderDismissAction() {
        if (!onDismissReview) return null
        return <InfoButton size="small" sx={{ marginRight: 1 }} text="Dismiss" onClick={onDismissReview} />
    }
}
